import React from 'react';
import Lottie from 'react-lottie';
import styled, { keyframes } from 'styled-components';
import { Fill } from '../../../ui/Fill';
import { LoadingBar } from '../../../ui/LoadingBar';
import { Position } from '../../../ui/Position';
import { Box, remInPx } from './../../../ui';
import animData from './ReplayLoaderAnimation.json';

const animOpts = {
    loop: true,
    autoplay: true,
    animationData: animData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

const blurIn = keyframes`
    0% { background: transparent; backdrop-filter: blur(0) }
    50% { background: transparent; backdrop-filter: blur(.5rem) }
    100% { background: #F6FAFD; backdrop-filter: blur(1rem) }
`;

const BlurIn = styled(Fill)`
    background: #F6FAFD; 
`;

export const ReplayLoader = ({ progress }: { progress: number | false }) => {
    return <BlurIn id="blur">
        <Position at="center">
            <Box>
                <Lottie options={animOpts}
                    height={remInPx(4)}
                    width={remInPx(4)}
                />
                <Box padding="2 0" width="18">
                    <LoadingBar progress={progress || 0} />
                </Box>
            </Box>
        </Position>
    </BlurIn>;
};
